// extracted by mini-css-extract-plugin
export default {"header":"userExercisesTable_header__rIYpv","noExercises":"userExercisesTable_noExercises__iOLoL","loading":"userExercisesTable_loading__21tOm"};